/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.custom.enrichment.rpc.client.SmartPropertyStatusService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export namespace ComHubspotCustomEnrichmentModels {
  export type SmartPropertyStatusError = {
    errorType: ErrorType;
    chirpErrorMessage?: string;
    coordinates?: ChirpMethodCoordinates;
    causalChain: Default<CausalChainLink[]>;
    shouldRetry: Default<boolean>;
  };
}

export type ErrorType = 'CONTEXT_MISSING_PORTAL_ID' | unhandledEnumCase;

export type SmartPropertyStatus =
  | 'COMPLETE_SUCCESS'
  | 'COMPLETE_NO_RESULT'
  | 'RUNNING'
  | 'FAILURE'
  | 'FAILURE_PII_DETECTED'
  | unhandledEnumCase;

export type SmartPropertyStatusMetadata = {
  error?: ComHubspotCustomEnrichmentModelsPropertyStatuses.SmartPropertyStatusError;
};

export namespace ComHubspotCustomEnrichmentModelsPropertyStatuses {
  export type SmartPropertyStatusError =
    | 'INTERNAL_ERROR'
    | 'RATE_LIMIT_EXCEEDED'
    | 'INSUFFICIENT_CREDITS'
    | 'CAP_EXCEEDED'
    | 'GOVERNANCE_DISABLED'
    | 'OBJECT_NOT_FOUND'
    | 'INVALID_PROPERTY'
    | 'MISSING_PROPERTY_POINTER'
    | 'INVALID_PROPERTY_POINTER'
    | 'EMPTY_PROPERTY_POINTER'
    | 'INTERNAL_AGENT_ERROR'
    | 'INVALID_AGENT_RESULT'
    | 'INVALID_AGENT_RESULT_PII_DETECTED'
    | 'CRM_WRITE_ERROR'
    | 'ENRICHMENT_DEADLINE_EXCEEDED'
    | 'INVALID_DOMAIN'
    | 'DOMAIN_INACTIVE'
    | 'DOMAIN_REDIRECT'
    | 'MISSING_EMAIL'
    | 'MISSING_REQUIRED_OBJECT_PROPERTY'
    | 'NO_TRANSCRIPT_DATA'
    | 'GENERATIVE_AI_CUSTOMER_CONVERSATION_DISABLED'
    | 'NO_ENGAGEMENT_DATA'
    | 'URL_CRAWL_ERROR'
    | 'INVALID_TOKEN'
    | 'EMPTY_TOKEN'
    | 'WRITE_NOT_PERMITTED'
    | unhandledEnumCase;
}

export type SmartPropertyStatusBatchRequest = {
  objectIds: Default<number[]>;
  propertyNames: Default<string[]>;
  objectTypeId: Default<string>;
};

/**
 *  Represents a batch response for smart property statuses.
 *  <p>The outer key is the objectId, and the inner key is the property name.</p>
 */
export type SmartPropertyStatusBatchResponse = {
  responses: Default<
    Record<string, Record<string, SmartPropertyStatusResponse>>
  >;
};

export type SmartPropertyStatusResponse = {
  status: SmartPropertyStatus;
  metadata: Default<SmartPropertyStatusMetadata>;
  smartPropertyResultId?: number;
};

export type GetSmartPropertyBatchRequestType =
  Requestify<SmartPropertyStatusBatchRequest>;
export type GetSmartPropertyBatchResponseType =
  SmartPropertyStatusBatchResponse;
export type GetSmartPropertyBatchErrorType =
  ComHubspotCustomEnrichmentModels.SmartPropertyStatusError & HubspotMetadata;
export const getSmartPropertyBatchRpc: ChirpAvroRpcDetails<
  GetSmartPropertyBatchRequestType,
  GetSmartPropertyBatchResponseType,
  GetSmartPropertyBatchErrorType,
  false
> = {
  serviceName:
    'com.hubspot.custom.enrichment.rpc.client.SmartPropertyStatusService',
  rpcName: 'getSmartPropertyBatch',
  auth: 'app',
  fingerprint: 'gKaM-Ge2wTK5hca_0nMyFRy7eWMKXE8Z',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
